// extracted by mini-css-extract-plugin
export default {"container":"style_container__fgCPz","small":"style_small__+DyeD","h":"style_h__Zjf24","m":"style_m__FWPh8","l":"style_l__+SIC9"};